export default __webpack_public_path__ + "static/media/417hz-remove-negative-energy.7faf6200.ogg";